import { IStateSliceDefaults, StateSliceName } from '../store.models';

import { IAuthStateModel } from './auth.models';

export const authStateDefaults: IStateSliceDefaults<IAuthStateModel> = Object.freeze({
    sliceName: StateSliceName.AUTH,
    defaults: {
        authorization: undefined,
        authentication: undefined
    }
});
